import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Advance Java</h1>
            <br />
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/Java.png")} alt="" />
          </div>
          <div className="heading">
            <h4 style={{ color: "blue" }}>Introduction</h4>
            <ul>
              <li>
                JAVA is a general-purpose server-side programming language
                originally designed for web application development to produce
                dynamic web pages. This is a three / four days course designed
                for the beginners to understand the JAVA Programming.
              </li>
            </ul>

            <h4 style={{ color: "blue" }}>Course Objective</h4>
            <ul>
              <li>
                Develop client/server applications and TCP/IP socket
                programming, Update and retrieve the data from the databases
                using SQL, Develop distributed applications using RMI, Develop
                server side programs in the form of Servlets and JSP
              </li>
            </ul>

            <h4 style={{ color: "blue" }}>Prerequisite</h4>
            <ul>
              <li>
                Fundamental Knowledge of Object Oriented Programming Using C++,
                Core Java Programming Concepts would be helpful.
              </li>
            </ul>

            <h3 style={{ color: "blue" }}>Course Content</h3>

            <h4>Introduction to Java Programming</h4>
            <ul>
              <li>Overview of Object Oriented Programming Concepts</li>
              <li>Overview of Core Java Concepts</li>
            </ul>

            <h4>Java Database Connectivity (JDBC)</h4>
            <ul>
              <li>Define JDBC API </li>
              <li>
                Describe the various JDBC drivers o Identify JDBC products{" "}
              </li>
              <li>Outline JDBC design considerations </li>
              <li>
                Describe the Two-Tier Client Server Model o Use JDBC to access a
                database o Set up a connection to the database o Create and
                execute SQL Statements.{" "}
              </li>
              <li>Describe the ResultSet object </li>
              <li>Describe the ResultSetMetaData interface </li>
              <li>Define and create stored procedures </li>
              <li>Understand the importance of database enquiry </li>
            </ul>

            <h4>Network Programming</h4>
            <ul>
              <li>Understand how the internet works </li>
              <li>Describe the classes of the java.net package </li>
              <li>Explain Client/Server computing</li>
              <li>Socket Programming </li>
              <li>ServerSocket Class Methods </li>
              <li>Socket Class Methods </li>
              <li>InetAddress Class Methods </li>
              <li>Describe Java’s Web-related classes </li>
            </ul>

            <h4>Remote Method Invocation</h4>
            <ul>
              <li>Describe distributed Applications </li>
              <li>Build distributed Applications </li>
              <li>Define RMI </li>
              <li>Outline the Java Distributed Model </li>
              <li>List the jave.rmi packages </li>
              <li>Explain the three-tiered layering of Java RMI </li>
              <li>Explain the three-tiered layering of Java RMI </li>
              <li>Implement RMI on a Remote and Local Host </li>
              <li>Describe Remote Objects </li>
            </ul>

            <h4>Servlets</h4>
            <ul>
              <li>Define a Servlet </li>
              <li>Compile Servlets </li>
              <li>List the advantages of using servlets </li>
              <li>Explain the life cycle of a servlet </li>
              <li>Describe an HTTP Servlet </li>
              <li>
                Use a Servlet to retrieve information o Define Session Tracking{" "}
              </li>
              <li>
                Describe InterServlet communication o Use a servlet to access a
                database{" "}
              </li>
            </ul>

            <h4>Java Server Pages (JSP)</h4>
            <ul>
              <li>Architecture, Life cycle </li>
              <li>JSP tags, Expressions </li>
              <li>JSP with database </li>
              <li>Implicit objects </li>
              <li>Expression language </li>
              <li>Exception Handling in JSP </li>
              <li>Session management </li>
              <li>Directives, Using java beans </li>
              <li>Tag Mibraries </li>
              <li>Miscellaneous tags </li>
              <li>Custom tags- bodyless </li>
              <li>Body Tags </li>
            </ul>

            <h4>Java Spring</h4>
            <ul>
              <li>Writing Beans </li>
              <li>Configuring a Properties File </li>
              <li>Schema Based Configuration </li>
              <li>Beans and Container </li>
              <li>Application Context </li>
              <li>Data Validation and Conversion </li>
              <li>JDBC with Spring </li>
            </ul>

            <h4>Hibernate</h4>
            <ul>
              <li>Introduction </li>
              <li>Architecture of Hibernate </li>
              <li>Annotation and XML Configuration </li>
              <li>Association and Mapping </li>
              <li>Hibernate Query Language </li>
              <li>JPA Query Language </li>
              <li>Memory Management </li>
              <li>ORM </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
